<template>
<div class="chapter">
<div class="inner_page">
<h1>Copyright</h1>
<p class="sectiontop" style="text-align: center;">Diversion Books<br/>
  A Division of Diversion Publishing Corp.<br/>
  443 Park Avenue South, Suite 1008<br/>
  New York, NY 10016<br/>
<a href="http://www.DiversionBooks.com" target="_blank">www.DiversionBooks.com</a></p>
<p class="sectiontop" style="text-align: center;">Copyright © Edna Buchanan<br/>
  All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</p>
<p class="sectiontop" style="text-align: center;">This is a work of fiction. Names, characters, places and incidents either are the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events or locales is entirely coincidental.</p>
<p class="sectiontop" style="text-align: center;">For more information, email <a href="mailto:info@diversionbooks.com">info@diversionbooks.com</a></p>
<p class="sectiontop" style="text-align: center;">Diversion Books Omnibus Edition 2014<br/>
  ISBN: 978-1-62681-511-7</p>
<div style="page-break-after: always;">
<div style="display: none;"></div>
</div>
<h1 class="sigil_not_in_toc">More from Edna Buchanan</h1>
<p style="text-align: center;"><b><i>Fiction</i></b></p>
<p class="single" style="text-align: center;"><span href="#/Text/morefrom" title="Link target outside of Sample">Nobody Lives Forever</span><br/></p>
<p style="text-align: center;"><b><i>Non-Fiction</i></b></p>
<p style="text-align: center;">Carr: Five Years of Rape and Murder</p>
<p style="text-align: center;"><span href="#/Text/morefrom" title="Link target outside of Sample">Never Let Them See You Cry</span><br/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?2ad337f6